import React from "react";
import { motion } from "framer-motion";

const ToastNotification = ({
    message,
    image,
    onClose,
}) => {
    if (!message) return null;

    return (
        <motion.div
            className="flex items-center space-x-4 p-4 bg-white shadow-lg rounded-lg fixed top-5 right-5 z-50"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 1 }}
        >
            {image && (
                <img
                    src={image}
                    alt="participant"
                    className="w-10 h-10 rounded-full"
                />
            )}
            <p className="text-sm font-medium">{message}</p>
            <button
                onClick={onClose}
                className="ml-4 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
                ✕
            </button>
        </motion.div>
    );
};

export default ToastNotification;
